// src/components/states/hamburg.js
export const hamburg = {
  slug: "hamburg",
  name: "Hamburg",
  hero: {
    eyebrow: "Bundesland-Übersicht",
    title: "Erdwärme in Hamburg",
    subtitle:
      "Übersicht zu Förderung, Genehmigungen, Leitfaden, Fachkarte und typischen Standortfaktoren für oberflächennahe Geothermie in Hamburg – kompakt und praxisnah.",
    infoBox:
      "Für Erdwärmesonden ist in Hamburg eine wasserrechtliche Erlaubnis erforderlich. Die BUKEA stellt dazu einen Leitfaden, Antragsunterlagen sowie Formblätter für Bau und Überwachung bereit.",
  },
  seo: {
    title:
      "Erdwärme in Hamburg – Förderung, Genehmigung & Fachkarte | Erdwärme-Experten",
    description:
      "Kurzübersicht Erdwärme Hamburg: KfW-Förderung, wasserrechtliche Erlaubnis für Erdwärmesonden, Leitfaden Erdwärmenutzung, Fachkarte oberflächennahe Geothermie und typische Standortfaktoren.",
    canonical: "https://www.erdwaerme-experten.de/bundeslaender/hamburg",
  },

  facts: [
    {
      title: "Förderung (Bund)",
      icon: "BadgeCheck",
      color: "from-rose-600 to-rose-500",
      bullets: [
        "Heizungstausch-Zuschuss über KfW Programm 458 für Bestandsgebäude",
        "30 % Grundförderung; persönliche Boni können die Quote erhöhen",
        "Maximal 80 %; kein separater Effizienzbonus für Erdwärme",
      ],
      note:
        "Förderstand 21.07.2026. Die tatsächliche Förderfähigkeit hängt von Gebäude, Eigentum, Einkommen und weiteren Voraussetzungen ab.",
      link: {
        label: "KfW 458 (offiziell)",
        href: "https://www.kfw.de/inlandsfoerderung/Privatpersonen/Bestehende-Immobilie/F%C3%B6rderprodukte/Heizungsf%C3%B6rderung-f%C3%BCr-Privatpersonen-Wohngeb%C3%A4ude-%28458%29/",
      },
    },
    {
      title: "Genehmigung & Vorgehen",
      icon: "ShieldCheck",
      color: "from-slate-700 to-slate-600",
      bullets: [
        "Für den Einbau von Erdwärmesonden ist eine wasserrechtliche Erlaubnis erforderlich.",
        "Zuständig ist in Hamburg die Abteilung Wasserwirtschaft der BUKEA.",
        "Für Planung und Antragstellung gibt es einen offiziellen Leitfaden zur Erdwärmenutzung.",
      ],
      note:
        "Gerade in Hamburg ist der Grundwasserschutz ein zentraler Punkt bei Planung und Genehmigung.",
      link: {
        label: "Hamburg: Oberflächennahe Geothermie",
        href: "https://www.hamburg.de/politik-und-verwaltung/behoerden/bukea/themen/boden-und-geologie/geologie/oberflaechennahe-geothermie-168864",
      },
    },
    {
      title: "Leitfaden & Formulare",
      icon: "FileText",
      color: "from-indigo-700 to-indigo-600",
      bullets: [
        "Leitfaden zur Erdwärmenutzung in Hamburg als zentrale Orientierung",
        "Formular Druckprüfung verfügbar",
        "Formblätter 1–4 für Bau und Überwachung von Erdwärmesonden verfügbar",
      ],
      note:
        "Das ist für Bauherrschaft, Bohrfirma und Fachplanung praktisch, weil die Unterlagen direkt gebündelt bereitstehen.",
      link: {
        label: "Hamburg: Erdwärmenutzung – Downloads",
        href: "https://www.hamburg.de/politik-und-verwaltung/behoerden/bukea/themen/wasser/grundwasser/start-erdwaermenutzung-176010",
      },
    },
    {
      title: "Datengrundlage & Fachkarte",
      icon: "Layers",
      color: "from-emerald-700 to-emerald-600",
      bullets: [
        "Hamburg verweist auf die Fachkarte „Oberflächennahe Geothermie“ als Orientierung zur Grundstückseignung.",
        "Die Karte dient als erste Potenzialabschätzung für einen Standort.",
        "Für die konkrete Realisierung bleibt die behördliche Prüfung im Einzelfall entscheidend.",
      ],
      note:
        "Für deine Seite ist das gut nutzbar: Hamburg hat damit eine klare, verständliche Einstiegslogik für Interessierte.",
      link: {
        label: "Hinweis auf die Fachkarte",
        href: "https://www.hamburg.de/politik-und-verwaltung/bezirke/bezirksamt-eimsbuettel/klimagerecht-bauen-60054",
      },
    },
  ],

  dataCards: [
    {
      title: "Welche Daten sind verfügbar?",
      icon: "Layers",
      desc:
        "Hamburg bietet eine Fachkarte zur oberflächennahen Geothermie sowie behördliche Leitfäden und Formblätter als guten Einstieg in die Standortprüfung.",
    },
    {
      title: "Was ist häufig der Engpass?",
      icon: "Droplets",
      desc:
        "In Hamburg ist der Grundwasserschutz besonders relevant. Deshalb ist die wasserrechtliche Erlaubnis für Erdwärmesonden der zentrale Genehmigungsschritt.",
    },
    {
      title: "Was macht euer GeoReport daraus?",
      icon: "FileText",
      desc:
        "Der GeoReport bündelt Standortdaten, erste technische Einschätzungen und praktische Hinweise zur Umsetzbarkeit, damit Angebote und Planungsschritte besser eingeordnet werden können.",
    },
  ],

  faq: [
    {
      q: "Brauche ich in Hamburg für Erdwärmesonden eine Genehmigung?",
      a: "Ja. Für den Einbau von Erdwärmesonden ist in Hamburg eine wasserrechtliche Erlaubnis erforderlich. Zuständig ist die Abteilung Wasserwirtschaft der BUKEA.",
      links: [
        {
          label: "Hamburg: Oberflächennahe Geothermie",
          href: "https://www.hamburg.de/politik-und-verwaltung/behoerden/bukea/themen/boden-und-geologie/geologie/oberflaechennahe-geothermie-168864",
        },
      ],
    },
    {
      q: "Gibt es in Hamburg offizielle Unterlagen für Planung und Bau?",
      a: "Ja. Hamburg stellt einen Leitfaden zur Erdwärmenutzung, ein Formular zur Druckprüfung sowie Formblätter für Bau und Überwachung von Erdwärmesonden bereit.",
      links: [
        {
          label: "Hamburg: Erdwärmenutzung – Downloads",
          href: "https://www.hamburg.de/politik-und-verwaltung/behoerden/bukea/themen/wasser/grundwasser/start-erdwaermenutzung-176010",
        },
      ],
    },
    {
      q: "Gibt es eine Karte oder Ersteinschätzung für mein Grundstück?",
      a: "Hamburg verweist auf eine Fachkarte „Oberflächennahe Geothermie“, mit der sich das Potenzial eines Grundstücks grob vorprüfen lässt. Für die tatsächliche Zulässigkeit ist aber immer die Prüfung des Einzelfalls maßgeblich.",
      links: [
        {
          label: "Hinweis auf die Fachkarte",
          href: "https://www.hamburg.de/politik-und-verwaltung/bezirke/bezirksamt-eimsbuettel/klimagerecht-bauen-60054",
        },
      ],
    },
  ],

  cta: {
    title: "Hamburg-Standort prüfen (datenbasiert)",
    text:
      "Du bekommst eine standortbezogene Vorabschätzung: erste Einordnung des Standorts, Hinweise zu Untergrund und Genehmigung sowie eine technische Vorprüfung für Sonde oder Kollektor.",
    primary: {
      label: "Jetzt Standort-Report erstellen",
      href: "/report",
      title: "Erdwärme Standort-Report für Hamburg erstellen",
    },
    secondary: { label: "Erst Grundlagen ansehen", href: "/flache-geothermie" },
    footnote:
      "Tipp: In Hamburg lohnt sich vorab der Blick in die Fachkarte und in den offiziellen Leitfaden zur Erdwärmenutzung.",
  },
};